<div class="modal-body">
  <div class="container-fluid">
    <!-- <div class="grid-col flex-auto">
    <legend class="usa-legend usa-legend--medium">Review Email Notification</legend>
  </div> -->

  <ul class="usa-card-group grid-row grid-gap-0">
    <li class="usa-card tablet-lg:grid-col-12 widescreen:grid-col-12">
      <div class="usa-card__container">
        <div class="usa-card__header">
          <h4 class="usa-card__heading" [innerHTML]="emailSubject"> </h4>
        </div>
        <div class="usa-card__body">

          <p [innerHTML]="emailBody">
          </p>
        </div>
        <div class="usa-card__body">
          @if (attachments && attachments.length > 0) {
            Attachments
            <div>
              <ul>
                @for (item of attachments; track item) {
                  <li>
                    {{ item.fileName }}
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      </div>
    </li>
  </ul>
</div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="closeModal()">Close</button>
</div>
